export default __webpack_public_path__ + "static/media/iconTiktokColor.8bf06174.png";